/**
 * Utilitaire pour gérer les erreurs de manière cohérente
 */

/**
 * Extrait le statut HTTP d'une erreur
 * @param {Error} error - L'objet erreur
 * @returns {number|null} - Le statut HTTP ou null
 */
export const extractErrorStatus = (error) => {
    if (!error || !error.message) return null;
    const statusMatch = error.message.match(/status: (\d+)/);
    return statusMatch ? parseInt(statusMatch[1]) : null;
};

/**
 * Classe pour wrapper les erreurs API
 */
export class APIError extends Error {
    constructor(message, status = null) {
        super(message);
        this.name = 'APIError';
        this.status = status;
    }
}

/**
 * Traite une erreur API et retourne l'état approprié
 * @param {Error} error - L'objet erreur
 * @param {string} defaultMessage - Message par défaut
 * @returns {{error: string, status: number|null}} - État d'erreur
 */
export const processError = (error, defaultMessage = 'Une erreur est survenue') => {
    const status = extractErrorStatus(error);
    const errorMessage = error?.message || defaultMessage;
    
    console.error(errorMessage, error);
    
    return {
        error: errorMessage,
        status: status,
    };
};

/**
 * Détermine le type de page d'erreur à afficher
 * @param {number|null} status - Le statut HTTP
 * @returns {'500' | '404' | null} - Le type d'erreur
 */
export const getErrorPageType = (status) => {
    if (status === 500) return '500';
    if (status === 404 || !status) return '404';
    return null;
};
